import React, { useCallback, useState } from "react";
import {
  Card,
  Button,
  Col,
  Row,
  Input,
  CardBody,
  CardFooter,
} from "reactstrap";
import closeOutline from "../../../../assets/icons/close-outline.svg";
import deliveryCar from "../../../../assets/icons/delivery-car.svg";
import successIcon from "../../../../assets/icons/success-icon.svg";
import { useDispatch, useSelector } from "react-redux";
import I18n from "../../../../../i18n/utils";
import "./BusinessUnitOverridesImportForm.scss";
import XSLX from "xlsx";
import CFASpinner from "../../../Common/CFASpinnner/CFASpinner";
import { resetBulkUploadStatus } from "../../../../redux/features/deliveryPartnerSlice";
import { RootState } from "../../../../redux/store/store";
import {
  alertRefreshDeliveryPartners,
  updateBusinessUnitOverrides,
} from "../../../../redux/features/deliveryPartnerSlice";
import { getOktaUser } from "../../../../utils/LocalStorage";
import { LOADING, SUCCEEDED } from "../../../../redux/features/constants";

function BusinessUnitOverridesImportForm(props: any) {
  const oktaUserInfo = getOktaUser();
  const [validationError, setValidationError] = useState<string>("");
  const [importData, setImportData] = useState<any>([]);
  const [message, setMessage] = useState<string>("");
  let dispatch = useDispatch();

  let error = false;

  const overrideUpdateStatus = useSelector(
    (state: RootState) => state.deliveryPartners.overrideUpdateStatus
  );

  if (overrideUpdateStatus === "failed") {
    error = true;
  }

  let loading = overrideUpdateStatus === LOADING;

  let errorMessage = useSelector(
    (state: RootState) => state.deliveryPartners.error
  );

  function setNullValues(records: any) {
    for (let i = 0; i < records.length; i++) {
      if (records[i][24] == null) {
        records[i][24] = 0;
      }
      if (records[i][19] == null) {
        records[i][19] = 0;
      }
    }
  }

  function handleChangeInput(event: any) {
    dispatch(resetBulkUploadStatus());
    error = false;
    errorMessage = "";
    setImportData([]);
    setValidationError("");
    if (event == null) return;
    let reader = new FileReader();
    reader.readAsArrayBuffer(event.target.files[0]);
    reader.onload = (e: any) => {
      const data = e.target.result;
      const binaryData = XSLX.read(data, { type: "array" });
      const worksheet = binaryData.Sheets[binaryData.SheetNames[0]];
      const records = XSLX.utils.sheet_to_json(worksheet, {
        header: 1,
        blankrows: false,
      });
      records.shift();
      let overrides = records.map((r) => {
        // @ts-ignore
        let startTimestamp = r[3] ? r[3].split("-").map(Number) : null;
        // @ts-ignore
        let endTimestamp = r[4] ? r[4].split("-").map(Number) : null;
        // @ts-ignore
        let override = {
          // @ts-ignore
          locationNumber: r[0],
          // @ts-ignore
          commissionRate: r[1],
          // @ts-ignore
          overrideCommissionFee: r[2],
          startTimestamp,
          endTimestamp,
          // @ts-ignore
          deliveryPartnerId: r[6],
          lastUpdatedBy: oktaUserInfo[2],
          lastUpdatedTimestamp: Date.now(),
          createdBy: oktaUserInfo[2],
          creationTimestamp: Date.now(),
          objectVersionNumber: 0,
        };
        // @ts-ignore
        const deliveryPartnerBusinessUnitOverrideId = r[5];
        // If the override id is not null, then update the override
        if (deliveryPartnerBusinessUnitOverrideId) {
          return {
            deliveryPartnerBusinessUnitOverrideId,
            ...override,
          };
        } else {
          return override;
        }
      });
      var invalidOverrides = overrides.filter(
        (r) =>
          typeof r.locationNumber !== "string" || r.locationNumber.length !== 5
      );
      if (invalidOverrides.length > 0) {
        // @ts-ignore
        overrides = null;
        var text = `${invalidOverrides.length} ${I18n.t(
          "APP_BUSINESS_UNIT_OVERRIDES_IMPORT_FILE_ERRORS"
        )}: ${invalidOverrides[0].locationNumber} ${I18n.t(
          "APP_BUSINESS_UNIT_OVERRIDES_IMPORT_FILE_INVALID_LOCATION"
        )}.`;
        setValidationError(text);
      } else {
        setValidationError("");
      }
      setImportData(overrides);
    };
  }

  function submit() {
    // @ts-ignore
    dispatch(updateBusinessUnitOverrides(importData));
  }
  const close = useCallback(() => {
    dispatch(resetBulkUploadStatus());
    error = false;
    errorMessage = "";
    setImportData([]);
    setValidationError("");
    props.close(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const closeSuccess = useCallback(() => {
    dispatch(resetBulkUploadStatus());
    dispatch(alertRefreshDeliveryPartners());
    error = false;
    errorMessage = "";
    props.close(true);
  }, []);

  let dataPreview = <></>;
  if (importData != null && importData.length != 0) {
    const rows: any[] = [];
    for (let i = 0; i < importData.length && i < 5; i++) {
      rows.push(
        <tr key={importData[i].locationNumber}>
          <td>{importData[i].locationNumber}</td>
          <td>{importData[i].commissionRate}</td>
          <td>{importData[i].startTimestamp}</td>
          <td>{importData[i].endTimestamp}</td>
        </tr>
      );
    }
    dataPreview = (
      <>
        <Row className="input-row">
          <table>
            <thead>
              <tr>
                <th>Store&nbsp;#</th>
                <th>MPF Cap</th>
                <th>Effective Date</th>
                <th>Rollback Date</th>
              </tr>
            </thead>
            <tbody>{rows}</tbody>
          </table>
        </Row>
        <Row className="input-row">
          <Col>{importData.length} records...</Col>
        </Row>
      </>
    );
  }

  const imprt = (
    <Row>
      <Col className="dashboard-card">
        <Card className="dashboard-card">
          <CardBody>
            <Row className="close-button-container">
              <img
                alt=""
                src={closeOutline}
                className="close-modal-icon"
                onClick={close}
              />
            </Row>
            <Row className="container">
              <Col className="bu-override-import-title-container">
                <img
                  alt=""
                  src={deliveryCar}
                  className="bu-override-import-title-icon"
                />
                <h2 className="bu-override-import-title">
                  {I18n.t("APP_BUSINESS_UNIT_OVERRIDES_IMPORT_FILE_TITLE")}
                </h2>
              </Col>
            </Row>
            <Row className="input-row">
              <Input
                type="file"
                id="input-excel"
                onChange={handleChangeInput}
              />
            </Row>
            {dataPreview}
            {error && (
              <Row>
                <h4 className="error">{errorMessage}</h4>
              </Row>
            )}
            {validationError && (
              <Row>
                <h4 className="error">{validationError}</h4>
              </Row>
            )}
            <CardFooter>
              {!loading ? (
                <Button
                  disabled={!importData}
                  className="submit-button"
                  block
                  onClick={submit}
                >
                  {I18n.t(
                    "APP_BUSINESS_UNIT_OVERRIDES_IMPORT_FILE_SUBMIT_TEXT"
                  )}
                </Button>
              ) : (
                <Row className="spinner-container">
                  <CFASpinner />
                </Row>
              )}
            </CardFooter>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );

  const submissionSuccess = (
    <Row>
      <Col className="success-container">
        <img alt="" src={successIcon} className="success-icon" />
        <h4>{I18n.t("APP_BUSINESS_UNIT_OVERRIDES_IMPORT_FILE_SUCCESS")}</h4>
        <Button className="go-back-button" block onClick={close}>
          {I18n.t("APP_BUSINESS_UNIT_OVERRIDES_IMPORT_FILE_CLOSE")}
        </Button>
      </Col>
    </Row>
  );

  return (
    <>
      <Col className="BusinessUnitOverridesImportForm container">
        {!(overrideUpdateStatus === SUCCEEDED) ? (
          <> {imprt} </>
        ) : (
          <> {submissionSuccess} </>
        )}
      </Col>
    </>
  );
}
export default BusinessUnitOverridesImportForm;
